(function () {
  function shouldRevealImmediatelyOnMobile(target) {
    if (!window.matchMedia || !window.matchMedia('(max-width: 749px)').matches) {
      return false;
    }

    return Boolean(
      target.closest('.chakrikka-product') ||
      target.closest('.chakrikka-featured-products__grid') ||
      target.closest('.chakrikka-testimonials__grid')
    );
  }

  function initReveals(root) {
    var scope = root || document;
    var targets = Array.prototype.slice
      .call(scope.querySelectorAll('.reveal,[data-reveal]'))
      .filter(function (el) {
        return !el.classList.contains('in');
      });

    if (!targets.length) return;

    var observerTargets = [];
    targets.forEach(function (target) {
      if (shouldRevealImmediatelyOnMobile(target)) {
        target.style.transitionDelay = '0ms';
        target.classList.add('in');
        return;
      }

      observerTargets.push(target);
    });

    if (!observerTargets.length) return;

    if (!('IntersectionObserver' in window)) {
      observerTargets.forEach(function (target) {
        target.classList.add('in');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;

          var target = entry.target;
          var delay = target.dataset.revealDelay;

          if (!delay) {
            delay = String((observerTargets.indexOf(target) % 4) * 90);
          }

          target.style.transitionDelay = delay + 'ms';
          target.classList.add('in');
          observer.unobserve(target);
        });
      },
      {
        threshold: 0.14,
        rootMargin: '0px 0px -8% 0px',
      }
    );

    observerTargets.forEach(function (target) {
      observer.observe(target);
    });
  }

  function boot() {
    initReveals(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initReveals(event.target);
  });

  /** Called after AJAX-injected markup (e.g. product-recommendations fetch). */
  window.chakrikkaInitReveals = function (root) {
    initReveals(root || document);
  };
})();
